module.exports = __webpack_public_path__ + "static/tsi-cardiaca-a37b71ee0843b82a0f85d1fe693fc942.jpg";